import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { z } from "zod";

import {
  communityResponseSchema,
  type CommunityResponse,
} from "@community-analytics/shared";

import { apiFetch } from "@shared/api";

import { communityQueryKeys } from "./keys";

const communitiesListSchema = z.array(communityResponseSchema);

/**
 * GET /api/communities — list of every community owned by the authed user.
 * Drives the header selector. Validated against the shared Zod array schema
 * so a backend drift fails loudly instead of rendering a malformed list.
 */
export function useCommunitiesQuery(): UseQueryResult<
  CommunityResponse[],
  Error
> {
  return useQuery<CommunityResponse[], Error>({
    queryKey: communityQueryKeys.list(),
    queryFn: async () => {
      const raw = await apiFetch<unknown>("/api/communities");
      return communitiesListSchema.parse(raw);
    },
    // List is small and rarely changes — opt out of the 30s overview poll
    // cadence inherited from the QueryClient default.
    refetchInterval: false,
  });
}
